var _path, _path2, _path3, _path4, _path5, _rect;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconUserTalkActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.125 15C13.2316 15 15.75 12.4816 15.75 9.375C15.75 6.2684 13.2316 3.75 10.125 3.75C7.0184 3.75 4.5 6.2684 4.5 9.375C4.5 12.4816 7.0184 15 10.125 15Z",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 9.75C16.5 9.33579 16.1642 9 15.75 9C15.3358 9 15 9.33579 15 9.75H16.5ZM9.75 11.25C9.33579 11.25 9 11.5858 9 12C9 12.4142 9.33579 12.75 9.75 12.75V11.25ZM15 9.75C15 10.0242 14.946 10.1945 14.8635 10.3183C14.78 10.4436 14.6165 10.5973 14.2615 10.7452C13.5125 11.0573 12.1472 11.25 9.75 11.25V12.75C12.1528 12.75 13.7875 12.5677 14.8385 12.1298C15.3835 11.9027 15.82 11.5877 16.1115 11.1504C16.404 10.7117 16.5 10.2258 16.5 9.75H15Z",
    fill: "#007FA1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.75 6C18.9878 6.49215 19.1764 7.07669 19.3051 7.72016C19.4338 8.36362 19.5 9.05339 19.5 9.75C19.5 10.4466 19.4338 11.1364 19.3051 11.7798C19.1764 12.4233 18.9878 13.0078 18.75 13.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 3C21.4755 3.88588 21.8527 4.93804 22.1101 6.09628C22.3675 7.25452 22.5 8.49611 22.5 9.75C22.5 11.0039 22.3675 12.2455 22.1101 13.4037C21.8527 14.562 21.4755 15.6141 21 16.5",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M2.08203 18.7498C3.06766 17.5755 4.29846 16.6313 5.68797 15.9835C7.07747 15.3357 8.59198 15 10.1251 15C11.6582 15 13.1727 15.3357 14.5622 15.9835C15.9517 16.6314 17.1825 17.5756 18.1681 18.7499",
    stroke: "#007FA1",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 15,
    y: 8.25,
    width: 1.5,
    height: 2.25,
    rx: 0.75,
    stroke: "#007FA1",
    strokeWidth: 1.5
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconUserTalkActive);
export default __webpack_public_path__ + "static/media/icon-user-talk-active.f8e5a67d6ab8c0beeb56ca98d92bfc60.svg";
export { ForwardRef as ReactComponent };